<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <!-- <p>{{ t('common.notAvailableYet') }}</p> -->
    <v-container>
      <h1>Gestión de Cajas</h1>
      <v-row>
        <v-col cols="12">
          <v-btn color="secondary" @click="showForm = false" v-if="showForm">
            Volver a la Lista
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!showForm">
        <v-col cols="12">
          <CajasList
            @edit="editCaja"
            @delete="openDeleteModal"
            @update:options="updateOptions"
            @newItem="createCaja"
          />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <CajaForm :itemId="editingCaja?.id" @saved="saveCaja" />
        </v-col>
      </v-row>

      <!-- Modal de confirmación para eliminar caja -->
      <v-dialog v-model="deleteModal" max-width="400px">
        <v-card>
          <v-card-title class="headline">Confirmar eliminación</v-card-title>
          <v-card-text>
            ¿Está seguro de que desea eliminar esta entrada de caja?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="deleteModal = false"
              >Cancelar</v-btn
            >
            <v-btn color="red darken-1" text @click="confirmDelete"
              >Eliminar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useCajaStore } from '@/stores/cajaStore'
import CajasList from '@/components/cajas/CajasList.vue'
import CajaForm from '@/components/cajas/CajaForm.vue'
import { userIsRecepcion } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'

const cajaStore = useCajaStore()

const showForm = ref(false)
const editingCaja = ref(null)

// Variables para el modal de eliminación
const deleteModal = ref(false)
const cajaToDelete = ref(null)

onMounted(async () => {})

function createCaja() {
  editingCaja.value = null
  showForm.value = true
}

function editCaja(caja) {
  editingCaja.value = caja
  showForm.value = true
}

function openDeleteModal(cajaId) {
  cajaToDelete.value = cajaId
  deleteModal.value = true
}

async function confirmDelete() {
  try {
    await cajaStore.deleteCaja(cajaToDelete.value)
    // await loadCajas()
    deleteModal.value = false
  } catch (error) {
    console.error('Error al eliminar caja:', error)
  }
}

async function saveCaja() {
  showForm.value = false
  // await loadCajas()
}

async function updateOptions(options) {
  console.log(options)
  // await loadCajas(options)
}
</script>
